<template>
  <!-- SIGN IN MODAL -->
  <b-modal
    @hide="onHandleCloseModal('signInModal')"
    v-model="onChangeSignInModal"
    :id="getModals.signInModalId"
    :ref="getModals.signInModalId"
    title="Login to Miraj"
    class="imp-popup"
    hide-footer
  >
    <div>
      <div class="p-3">
        <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
          <div class="row">
            <!-- MOBILE NUMBER -->
            <div class="col-12 mb-4">
             <input
                type="number"
                placeholder="Enter your phone number"
                class="form-control"
                maxlength="10"
                onkeyup="this.value=this.value.replace(/[^0-9]+/g,'');"
                onkeypress="if(this.value.length==10) return false;"
                :value="getSigninFormValues.userNumber"
                @input="
                  onHandleSignInFormValues({
                    event: $event,
                    name: 'userNumber',
                    value: $event.target.value,
                  })
                "
              />
            </div>

            <!-- CAPTCHA CODE -->
            <div class="col-12 mb-4">
              <input
                type="text"
                placeholder="Enter captcha code"
                class="form-control"
                :value="getSigninFormValues.captchaCode"
                @input="
                  onHandleSignInFormValues({
                    event: $event,
                    name: 'captchaCode',
                    value: $event.target.value,
                  })
                "
              />
              <div v-if="validationErrorMessage" class="text-rose-gold mt-2">
                {{ validationErrorMessage }}
              </div>
            </div>

            <!-- GENERATED CAPTCHA -->
            <div id="appcap">
              <div
                class="np-captcha-container"
                v-if="captcha && captcha.length"
              >
                <div class="np-captcha">
                  <div
                    v-for="(c, i) in captcha"
                    :key="i"
                    :style="{
                      fontSize: initialFontSizes[i] + 'px',
                      fontWeight: 800,
                      transform: 'rotate(' + initialRotationAngles[i] + 'deg)',
                    }"
                    class="np-captcha-character"
                  >
                    {{ c }}
                  </div>
                </div>
              </div>

              <!-- GENERATE BUTTON -->
              <div class="captchabutton">
                <router-link
                  class="text-rose-gold np-button"
                  to
                  @click.native="regenerateCaptcha"
                  >Generate new</router-link
                >
              </div>
            </div>

            <!-- PROCEED BUTTON -->
            <div class="col-12 mb-4">
              <button
                class="btn btn-primary w-100"
                @click="onSubmitUserSignIn2"
              >
                PROCEED
              </button>
            </div>
            <div class="col-12 text-center mb-3">
              <span class="">Not a user?</span>
              <router-link
                class="text-rose-gold"
                to
                @click.native="onHandleOpenModal('signUpModal')"
                >Register with us!</router-link
              >
            </div>
          </div>
        </div>
      </div>

      <div class="rainbow-line">
        <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "App",
  data() {
    return {
      showModal: true,
      captchaCode: "",
      userNumber: "",
      captchaLength: 5,
      captcha: [],
      initialFontSizes: [],
      initialRotationAngles: [],
      validationErrorMessage: "",
    };
  },
  computed: {
    onChangeSignInModal: {
      get() {
        return this.getModals.signInModal;
      },
      set(value) {
        if(!value)
        {
            this.resetCaptcha();
            this.onHandleCloseModal("signInModal");
        }          
      },
    },
    ...mapGetters([
      // Modal
      "getModals",
      "getSigninFormValues",
      // ERROR
      "getSigninFormError",
    ]),
  },

  mounted() {
    this.createCaptcha();
  },

  watch: {
    "getSigninFormValues.userNumber": function () {},
  },

  methods: {
    ...mapActions([
      "onHandleSignInFormValues",
      "onHandleCloseModal",
      "onSubmitUserSignIn",
      "onHandleOpenModal",
      "createCaptcha",
    ]),

    async validateMobileAndCaptcha() {
      const isMobileValid = await this.verifyMobileNumber(
        this.getSigninFormValues.userNumber
      );

      const isCaptchaValid = await this.verifyCaptcha(
        this.getSigninFormValues.captchaCode
      );

      this.isCaptchaCodeCorrect = isCaptchaValid;
      // Return true only if both mobile number and OTP are valid
      return isMobileValid && isCaptchaValid;
    },

    async verifyMobileNumber(mobileNumber) {
      return true;
    },

    async verifyCaptcha(captcha) {
      const generatedCaptcha = this.captcha.join("");
      return captcha === generatedCaptcha;
    },

    async onSubmitUserSignIn2() {
      // alert("check validation");
      const isValid = await this.validateMobileAndCaptcha();

      // console.log("isValid:", isValid);
      // console.log("isCaptchaCodeCorrect:", this.isCaptchaCodeCorrect);

      if (isValid && this.isCaptchaCodeCorrect) {
        this.onSubmitUserSignIn();
        // alert("Proceeding to showOtpModal");
      } else if (!isValid) {
        // alert("Incorrect captcha code. Please generate a new captcha.");
        this.validationErrorMessage = "Incorrect CAPTCHA. Please try again.";
      } else {
        this.regenerateCaptcha();
      }
    },

    createCaptcha() {
      let tempCaptcha = "";
      this.initialFontSizes = [];
      this.initialRotationAngles = [];

      for (let i = 0; i < this.captchaLength; i++) {
        const randomFontSize = this.getFontSize();
        const randomRotationAngle = this.getRotationAngle();

        this.initialFontSizes.push(randomFontSize);
        this.initialRotationAngles.push(randomRotationAngle);

        tempCaptcha += this.getRandomCharacter();
      }
      this.captcha = tempCaptcha.split("");
    },

    regenerateCaptcha() {
      // Save the current userNumber before regenerating captcha
      this.getSigninFormValues.captchaCode = "";
      this.validationErrorMessage = "";
      this.createCaptcha();

      // Restore the userNumber
      this.userNumber = currentUserNumber;
    },

    resetCaptcha(){
        this.getSigninFormValues.captchaCode = "";
        this.validationErrorMessage = "";
        this.createCaptcha();
    },

    getRandomCharacter() {
      const symbols = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      const randomNumber = Math.floor(Math.random() * 36);
      return symbols[randomNumber];
    },

    getFontSize() {
      const fontVariations = [14, 20, 30, 36, 40];
      return fontVariations[Math.floor(Math.random() * 5)];
    },

    getRotationAngle() {
      const rotationVariations = [5, 10, 20, 25, -5, -10, -20, -25];
      return rotationVariations[Math.floor(Math.random() * 8)];
    },

    onHandleUserNumberInput(value) {
      // Update the userNumber without regenerating the captcha
      this.userNumber = value;
    },
  },
};
</script>

<style>
.np-captcha-container {
  background: #eee;
  width: 274px;
  margin: 0 auto;
  margin: 0 auto 20px 20px !important;
}
.np-captcha {
  font-size: 24px;
  background: #151515;
}
.np-button {
  padding: 6px 10px;
  /* background: #fff;
  border: 1px solid #eee;
  border-radius: 6px; */
  font-size: 16px;
  margin: auto;
}
.np-captcha-character {
  display: inline-block;
  letter-spacing: 14px;
}
#appcap {
  display: flex;
  flex-direction: row;
}
.captchabutton {
  margin-top: 10px; /* Add margin-top to create space between the button and the captcha input */
}
</style>


// WEBPACK FOOTER //
// src/components/modals/login.vue